import React from 'react';
import { Link, useSearchParams } from 'react-router-dom'; // Import Link
import LoginForm from '../components/auth/LoginForm';
import primaryLogo from '../assets/logo/syncehs-lockup-black-v2.svg'; // Import the new logo

const LoginPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');
  const isConnectReturn = !!returnTo && returnTo.startsWith('/connect/accept/');
  const signupHref = isConnectReturn ? `/signup?returnTo=${encodeURIComponent(returnTo!)}` : '/get-started';

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-surface-bg to-accent-blue-wash px-4">
      {/* Item 2: Enhanced card shadow + transition */}
      <div className="w-full max-w-md p-8 sm:p-10 space-y-6 bg-surface-card rounded-xl shadow-xl">
        {/* Item 3: Logo with tighter spacing */}
        <div className="flex justify-center">
          <img
            className="h-auto w-60 max-w-full"
            src={primaryLogo}
            alt="SyncEHS Logo"
          />
        </div>
        {/* Item 4: Responsive heading */}
        <h2 className="font-display tracking-tight text-2xl sm:text-3xl font-bold text-center text-text-primary">
          Sign in to SyncEHS
        </h2>
        {isConnectReturn && (
          <div className="p-3 text-sm text-accent-blue bg-accent-blue-wash border border-accent-blue/30 rounded-lg text-center">
            Log in or create an account to accept your SyncConnect invitation.
          </div>
        )}
        <LoginForm />
        {/* Item 10: Muted signup text */}
        <p className="text-sm text-center text-text-muted">
          Don't have an account?{' '}
          <Link to={signupHref} className="font-medium text-accent-blue hover:text-accent-blue-hover hover:underline transition-colors">
            Sign up
          </Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
